import { PayBenchmarkingCompensationUnit } from 'libs/end-to-end/src/pay-benchmarking';
import { PayCompensationUnitDisplayValues } from 'libs/end-to-end/src/pay-benchmarking';
import { formatPriceAmountToString } from 'libs/end-to-end/src/currencies';
import { Heading } from 'apps/sigma2-ui/src/components/ui/Heading';
import { Paragraph } from 'apps/sigma2-ui/src/components/ui/Paragraph';
import React from 'react';

export const PayBenchmarkingCompensationTotalCompView = (props: {
  currency: string;
  compensationUnit: PayBenchmarkingCompensationUnit;
  totalCompensation: number;
  internalCompaRatio: number;
}) => {
  const { currency, compensationUnit, totalCompensation, internalCompaRatio } =
    props;

  const displayedTotalCompensation = formatPriceAmountToString({
    amount: totalCompensation,
    currency: currency,
  });

  return (
    <div className="flex justify-center">
      <div className="bg-white border-2 border-gray-200 rounded">
        <div className="p-4">
          <div className="flex gap-1 items-end justify-center">
            <Heading level={2} textColor={'text-black'}>
              {displayedTotalCompensation}
            </Heading>
            <Paragraph textColor="text-gray-600" className="text-sm">
              {PayCompensationUnitDisplayValues[compensationUnit]}
            </Paragraph>
          </div>
          <div className="flex gap-1 justify-center">
            <Paragraph textColor="text-black" className="text-sm">
              Internal compa-ratio:
            </Paragraph>
            <Paragraph textColor="text-black" className="text-sm font-bold">
              {internalCompaRatio}%
            </Paragraph>
          </div>
        </div>
      </div>
    </div>
  );
};
